import * as React from 'react'
import styled from 'styled-components'

import { LinkButton } from '../Styled/Shared'

const HomeWrapper = styled.div`
  flex: 1 0 auto;

  color: ${({ theme }) => theme.colors.invert};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const HomeContent = styled.div`
  max-width: 1444px;
  padding: 0 15px;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  h3 {
    font-size: ${({ theme }) => theme.home.h3Size};
    margin-bottom: 20px;
  }

  .landingH3 {
    font-size: 34px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 15px;
  }

  sub {
    vertical-align: sub;
    font-size: 20px;
  }

  h2 {
    font-size: ${({ theme }) => theme.home.h2Size};
    font-weight: normal;
    margin-bottom: 50px;
    line-height: 62px;
    letter-spacing: 0.1px;
  }

  ${LinkButton} {
    margin-right: 20px;
  }
`

const Home = () => {
  return (
    <HomeWrapper>
      <HomeContent>
        <div>
          <h3>Peikko Designer&reg; DELTABEAM SELECT</h3>
          <h3 className="landingH3">
            - a free online dimensioning tool for easy and <br />
            fast slim floor structure predesign. CO<sub>2</sub>e values <br />
            are now shown for both DELTABEAM&reg; and <br />
            DELTABEAM&reg; Green!
          </h3>

          <LinkButton to="/location">Start designing</LinkButton>
        </div>
      </HomeContent>
    </HomeWrapper>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/Components/Home/index.tsx